// extracted by mini-css-extract-plugin
export var layoutContainer = "_7e-0";
export var layoutContainerNoRounding = "_7e-6";
export var layoutContainerOpen = "_7e-5";
export var layoutContainerResizing = "_7e-1";
export var mainContent = "_7e-2";
export var resizeDivider = "_7e-3";
export var slidePanel = "_7e-4";